import React from "react";
import RealMap from "../../Maps/RealMap";
import { Maximize2, X } from "lucide-react";

export default function MapPanel({
  tasks = [],
  drivers = [],
  isMapZoomed,
  setIsMapZoomed,
}) {
  return (
    <>
      {/* -------- MINI MAP (BOTTOM PANEL) -------- */}
      {!isMapZoomed && (
        <div className="w-full px-3 mt-2  relative z-[10]">
          <div className="h-[240px] w-full border rounded-md relative overflow-hidden bg-white shadow-sm">
            {/* EXPAND BUTTON */}
            <button
              onClick={() => setIsMapZoomed(true)}
              className="absolute bottom-3 right-3 bg-white text-gray-900 p-2 rounded-lg shadow-lg z-[999]"
              title="Expand Map"
            >
              <Maximize2 size={18} />
            </button>

            <div className="w-full h-full">
              <RealMap Task={tasks} drivers={drivers} />
            </div>
          </div>
        </div>
      )}

      {/* -------- FULL SCREEN MAP (TOP LAYER FIX) -------- */}
      {isMapZoomed && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[99999]">
          <div className="w-full h-full bg-white relative">
            {/* CLOSE BUTTON */}
            <button
              onClick={() => setIsMapZoomed(false)}
              className="absolute top-4 right-4 bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg shadow-lg z-[100000]"
              title="Close Map"
            >
              <X size={18} />
            </button>

            <div className="w-full h-full">
              <RealMap Task={tasks} drivers={drivers} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
